<h1 mat-dialog-title>ODVETA</h1>
<div mat-dialog-content>
  <p>{{data.opponent}} tě vyzývá na odvetu</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Ne, díky</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Přijmout</button>
</div>
